import React from "react";
import { Box, Button, H1, H2, H3, Link, Text, Typography } from "components/ui";
import Head from "expo-router/head";
import { useAuth, useClerk, useUser } from "components/clerk";

import { emptySplitApi } from "store/baseApi";
import { useDispatch } from "react-redux";
import { VStack } from "components/ui";
import ScrollContainer from "components/general/ScrollContainer";
import Container from "components/general/Container";
import { useIsMobile } from "utils/hooks/useIsMobile";
import Breadcrumbs from "components/general/Breadcrumbs";
import TitledContainer from "components/general/TitledContainer";
import Seo from "components/general/Seo";
import { router } from "expo-router";
import PageHeader from "components/general/Headers/PageHeader";
import Section from "components/general/Section";
import { B } from "@expo/html-elements";

export default function Page() {
	const { isLoaded, isSignedIn, user } = useUser();
	const { userId, actor } = useAuth();
	const { signOut } = useClerk();
	const dispatch = useDispatch();

	const doSignOut = async () => {
		router.replace("/"); // Redirects to the home page

		await signOut();
	};

	const companyCollection: any = user?.publicMetadata?.companyData;

	function switchCompany(companyId: string) {
		if (!user) return;

		const existingMetadata = user.unsafeMetadata || {};

		user.update({
			unsafeMetadata: {
				...existingMetadata,
				companyId: companyId,
			},
		});

		dispatch(emptySplitApi.util.resetApiState());
	}

	const isMobile = useIsMobile();
	return (
		<ScrollContainer>
			<Seo title="My Profile | Abconet" description="View and update your personal account information, settings, and preferences." />
			<Container>
				<PageHeader title="My Profile" />
				<Section paddingHorizontal={16} bg="$basicwhite" paddingVertical={0}>
					<Box>
						<Text>{`Logged in as ${user?.firstName || ""} ${user?.lastName || ""}`.trim()}</Text>
					</Box>
				</Section>
				<Section bg="$basicwhite">
					{actor?.sub && (
						<Box>
							<H2>Currently Impersonating</H2>
							<H3>Extra Information</H3>
							<Text>UserId: {userId}</Text>
						</Box>
					)}
					<VStack gap={24}>
						<TitledContainer
							customTitle={() => (
								<VStack>
									<Typography weight="bold" sx={{ fontSize: 18 }}>
										Your details
									</Typography>
								</VStack>
							)}
						>
							<Box padding={16} paddingTop={6}>
								{companyCollection && (
									<>
										<Text mt={20} mb={10}>
											{" "}
											Company List{" "}
										</Text>
										<VStack justifyContent="space-between">
											{Object.entries(companyCollection).map(([companyId, company]: any, index) => (
												<Button padding={0} key={index} justifyContent="flex-start" onPress={() => switchCompany(companyId)} pb={5}>
													<Text>
														{" "}
														<Text
															style={{
																fontWeight: user?.unsafeMetadata?.companyId === companyId || Object.keys(companyCollection).length === 1 ? "bold" : "normal",
															}}
														>
															{company.name}
														</Text>
													</Text>
												</Button>
											))}
										</VStack>
									</>
								)}
							</Box>
						</TitledContainer>
						<TitledContainer title="Log in settings">
							<Box padding={16} paddingTop={6}>
								<Box justifyContent="flex-start">
									<Link href="/profile/change-password">Change Password</Link>
								</Box>
							</Box>
						</TitledContainer>
						<TitledContainer title="Notification Settings">
							<Box padding={16} paddingTop={6}>
								<Box justifyContent="flex-start">
									<Link href="/profile/notifications">Update Notification Preference</Link>
								</Box>
							</Box>
						</TitledContainer>
						{/* <TitledContainer title="My Availability">
							<Box padding={16} paddingTop={6}>
								<Box justifyContent="flex-start">
									<Button justifyContent="flex-start">
										<Text>Change Password</Text>
									</Button>
								</Box>
							</Box>
						</TitledContainer> */}
					</VStack>
					<Button mt={20} onPress={doSignOut}>
						<Text>Sign Out</Text>
					</Button>
				</Section>
			</Container>
		</ScrollContainer>
	);
}
